<template>
<div class="container">
  <h5 class="text-center mb-3">Cache Refresh</h5>

  <div class="row mt-5">
    <div class="col-auto mx-auto py-3 px-5 border">
      <table class="table table-hover">
        <tbody>
          <tr  v-for="b in beanNames" :key="b">
            <td>{{b}}</td>
            <td class="ps-5"><a @click="refreshBean(b)" title="refresh cache" style="cursor: pointer;"><i class="fas fa-sync"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'CacheRefresh',
  data: () => ({
    beanNames: [],
    retrieving: false
  }),
  mounted () {
    this.getBeanNames()
  },
  methods: {
    getBeanNames () {
      var urlstr = '/ax/refreshablebeannames'
      this.retrieving = true
      this.axios.get(urlstr)
        .then(response => {
          console.log(response)
          this.beanNames = response.data
          this.retrieving = false
        })
        .catch(error => {
          console.log(error)
          this.retrieving = false
        })
    },
    refreshBean (beanName) {
      var urlstr = '/ax/refresh/' + beanName
      this.retrieving = true
      this.axios.get(urlstr)
        .then(response => {
          console.log(response)
          this.$toasted.success('Cache refresh request submitted for ' + beanName)
          this.retrieving = false
        })
        .catch(error => {
          console.log(error)
          this.$toasted.error('Unexpected error encountered ... check console log')
          this.retrieving = false
        })
    }
  }
}
</script>
